// Axios and config
import Axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";

// Interfaces
import I_BaseAPIResponse from "src/common_interfaces/I_BaseAPIResponse";
import { I_SafetyEventWithApprovalHistory } from "../interfaces";

// UI utilities
import snackBar from "src/utilities/snackBar/SnackBar";

/**
 * Fetches safety events with full approval history.
 * Can filter by approval status, or fetch events started by the user.
 *
 * @param employeeId - ID of the employee
 * @param approvalStatusTypeId - (Optional) filter by approval status
 * @param createdByOnly - if true, fetch only events started by the user
 * @returns A list of safety events with full audit trail
 */
const getSafetyEventsWithApprovalHistory = async (
  employeeId: number,
  approvalStatusTypeId: number | null,
  createdByOnly: boolean
): Promise<I_SafetyEventWithApprovalHistory[]> => {
  try {
    const response = await Axios.get<
      I_BaseAPIResponse<I_SafetyEventWithApprovalHistory[]>
    >(
      `${process.env.REACT_APP_API_URL}/api/samsara/getSafetyEventsWithApprovalHistory`,
      {
        ...AxiosConfig.configValue(),
        params: {
          employeeId,
          approvalStatusTypeId,
          createdByOnly,
        },
      }
    );

    if (response.data.HasError) {
      console.error("API Error:", response.data.ErrorMessage);

      snackBar({
        type: "error",
        text: "Failed to load safety events with audit history",
        timeout: 5000,
      });

      return [];
    }

    return response.data.Data;
  } catch (error) {
    console.error("Network or parsing error:", error);

    snackBar({
      type: "error",
      text: "Unable to load safety events",
      timeout: 5000,
    });

    return [];
  }
};

export default getSafetyEventsWithApprovalHistory;
